import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@shared/ui/feedback/Toast';
import { cancelAccessInvite } from './api';
import {
  ACCESS_INVITES_QUERY_KEY,
  patchAccessInviteInCache,
} from './accessInviteCache';

/** Cancel an access invite and refresh the shared list cache (widget + list). */
export function useCancelAccessInviteMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: cancelAccessInvite,
    onSuccess: (_data, accessInviteId) => {
      patchAccessInviteInCache(queryClient, accessInviteId, { status: 'cancelled' });
      toast.success('Invite cancelled');
      void queryClient.invalidateQueries({ queryKey: ACCESS_INVITES_QUERY_KEY });
    },
    onError: (error) =>
      toast.danger(
        "Couldn't cancel invite",
        error instanceof Error ? error.message : undefined,
      ),
  });
}
